import React, { ReactNode } from 'react';
import NextSessionCard, { SessionType } from '../NextSessionCard';
import WelcomeMessage from '../WelcomeMessage';
import './WelcomeCard.less';

export type WelcomeCardProps = {
  avatar?: string;
  avatarAlt?: string;
  title?: ReactNode;
  text?: string;
  sessionCardTitle?: string;
  session?: SessionType;
  noSessionText: string;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  backGroundColor?:
    | 'indicator-good-10'
    | 'indicator-caution-10'
    | 'indicator-bad-10'
    | 'indicator-neutral-10'
    | null;
  onHover?: boolean;
};

const TWelcomeCard: React.FC<WelcomeCardProps> = ({
  avatar,
  avatarAlt,
  title,
  text,
  sessionCardTitle,
  session,
  noSessionText,
  backGroundColor,
  onHover,
}) => {
  const classNames = [`t-welcomeCard t-welcomeCard-bgColor-${backGroundColor}`];
  if (onHover) {
    classNames.push('cardHover');
  }

  return (
    <div className={classNames.join(' ')}>
      <div className="t-welcomeMessageInCard">
        <WelcomeMessage
          avatar={avatar}
          avatarAlt={avatarAlt}
          title={title}
          text={text}
        />
      </div>
      <div className="t-sessionCard">
        <NextSessionCard
          title={sessionCardTitle}
          session={session}
          noSessionText={noSessionText}
        />
      </div>
    </div>
  );
};

export default TWelcomeCard;
